// extracted by mini-css-extract-plugin
module.exports = {"titleImage":"KeyVisual_titleImage__RYj1Z"};